import routers from '@/router/routers'
import { getMenuTreetByUser } from '@/api/common'
import config from '@/common/config'
import store from '@/store'
import { Message, Spin } from 'iview'
import router from '@/router/index' // false  打开权限  true  关闭权限

// import MenuNewMethods from './new-menu'
import { getCodeList } from './code_group.js'
let test = false
// let test = false // false  打开权限  true  关闭权限
class MenuMethods {
  getAllMenu = () => {
    return Object.assign([], routers)
  }

  getMenu = () => {
    return new Promise(async (resolve) => {
      getMenuTreetByUser().then(async res => {
        const { code, data, msg } = res.data
        if (code == 0) {
          // console.log(data.menuMap)

          // 添加财务审核菜单-开始
          let newMenuItem = {
            'id': '99000000000000',
            'parentId': '0',
            'code': 'M99000000000000',
            'name': '财务审核',
            'type': 'M',
            'frontPath': 'financial-review',
            'sort': 99,
            'level': 0,
            'sysCode': 'MATERIAL',
            'position': 'LEFT_TREE',
            'children': [
              {
                'id': '99010000000000',
                'parentId': '99000000000000',
                'code': 'S99010000000000',
                'name': '采购进项票审核',
                'type': 'S',
                'frontPath': 'take-ticket-review',
                'sort': 1,
                'level': 1,
                'sysCode': 'MATERIAL',
                'position': 'LEFT_TREE',
                'children': [
                  {
                    'id': '99010100000000',
                    'parentId': '99010000000000',
                    'code': 'B99010100000000',
                    'name': '审核',
                    'type': 'B',
                    'sort': 1,
                    'level': 2,
                    'sysCode': 'MATERIAL',
                    'position': 'LEFT_TREE',
                    'children': [],
                    'buttons': [],
                    'title': '审核',
                    'enable': true,
                    'displayFlag': true
                  }
                ],
                'buttons': [
                  {
                    'id': '99010100000000',
                    'parentId': '99010000000000',
                    'code': 'B99010100000000',
                    'name': '审核',
                    'type': 'B',
                    'sort': 1,
                    'level': 2,
                    'sysCode': 'MATERIAL',
                    'position': 'LEFT_TREE',
                    'children': [],
                    'buttons': [],
                    'title': '审核',
                    'enable': true,
                    'displayFlag': true
                  }
                ],
                'title': '采购进项票审核',
                'enable': true,
                'displayFlag': true
              },
              {
                'id': '99020000000000',
                'parentId': '99000000000000',
                'code': 'S99020000000000',
                'name': '采购销项票审核',
                'type': 'S',
                'frontPath': 'sales-ticket-review',
                'sort': 3,
                'level': 1,
                'sysCode': 'MATERIAL',
                'position': 'LEFT_TREE',
                'children': [
                  {
                    'id': '99020100000000',
                    'parentId': '99020000000000',
                    'code': 'B99020100000000',
                    'name': '审核',
                    'type': 'B',
                    'sort': 1,
                    'level': 2,
                    'sysCode': 'MATERIAL',
                    'position': 'LEFT_TREE',
                    'children': [],
                    'buttons': [],
                    'title': '审核',
                    'enable': true,
                    'displayFlag': true
                  }
                ],
                'buttons': [
                  {
                    'id': '99020100000000',
                    'parentId': '99020000000000',
                    'code': 'B99020100000000',
                    'name': '审核',
                    'type': 'B',
                    'sort': 1,
                    'level': 2,
                    'sysCode': 'MATERIAL',
                    'position': 'LEFT_TREE',
                    'children': [],
                    'buttons': [],
                    'title': '审核',
                    'enable': true,
                    'displayFlag': true
                  }
                ],
                'title': '采购销项票审核',
                'enable': true,
                'displayFlag': true
              },
              {
                'id': '99030000000000',
                'parentId': '99000000000000',
                'code': 'S99030000000000',
                'name': '报废销项票审核',
                'type': 'S',
                'frontPath': 'scrap-sales-ticket-review',
                'sort': 4,
                'level': 1,
                'sysCode': 'MATERIAL',
                'position': 'LEFT_TREE',
                'children': [
                  {
                    'id': '99030100000000',
                    'parentId': '99030000000000',
                    'code': 'B99030100000000',
                    'name': '审核',
                    'type': 'B',
                    'sort': 1,
                    'level': 2,
                    'sysCode': 'MATERIAL',
                    'position': 'LEFT_TREE',
                    'children': [],
                    'buttons': [],
                    'title': '审核',
                    'enable': true,
                    'displayFlag': true
                  }
                ],
                'buttons': [
                  {
                    'id': '99030100000000',
                    'parentId': '99030000000000',
                    'code': 'B99030100000000',
                    'name': '审核',
                    'type': 'B',
                    'sort': 1,
                    'level': 2,
                    'sysCode': 'MATERIAL',
                    'position': 'LEFT_TREE',
                    'children': [],
                    'buttons': [],
                    'title': '审核',
                    'enable': true,
                    'displayFlag': true
                  }
                ],
                'title': '报废销项票审核',
                'enable': true,
                'displayFlag': true
              }
            ],
            'buttons': [],
            'title': '财务审核',
            'enable': true,
            'displayFlag': true,
            'loginFlag': 'wzyw'
          }

          data.menuTree.push(newMenuItem)

          data.menuMap.M99000000000000 = newMenuItem
          data.menuMap.S99010000000000 = newMenuItem.children[0]
          data.menuMap.S99020000000000 = newMenuItem.children[1]
          data.menuMap.S99030000000000 = newMenuItem.children[2]

          data.menuMap.B99010100000000 = newMenuItem.children[0].children[0]
          data.menuMap.B99020100000000 = newMenuItem.children[1].children[0]
          data.menuMap.B99030100000000 = newMenuItem.children[2].children[0]
          // 添加财务审核菜单-结束

          store.commit('set_menuList', data.menuMap ? data.menuMap : {})
          // console.log(getCodeList())
          /**
             * @description 初始化设置面包屑导航和标签导航
             */
          let allMenuList = routers // 本地路由

          let userMenuList = JSON.parse(sessionStorage.getItem('menuList')) // 后端所有路由文件

          let menuAllList = []
          getCodeList().forEach(code => {
            initAllCodeGroupsMenu(code, userMenuList, menuAllList)
          })
          allMenuList.forEach(menu => { // 将 本地路由 和 后端路由 进行循环过滤
            initAllMenu(menu, userMenuList, menuAllList)
          })
          // console.log('好地方',menuAllList)
          if (menuAllList.length <= 0) {
            Message.error('登录失败,该用户暂无菜单权限')
            router.replace({ path: '/login' })
            sessionStorage.clear()
            Spin.hide()
            return
          }

          // console.log('过滤之后得路由', menuAllList)// menuMap

          let currentMenuList = []
          if (data.menuTree) {
            data.menuTree.forEach(menu => {
              let currentMenu = initMenuTree(menu, menuAllList)
              if (currentMenu) currentMenuList.push(currentMenu)
            })
          }

          currentMenuList = await initRouterOther(currentMenuList, allMenuList)
          sortMenu(currentMenuList)
          // console.log('过滤之后得路由2', currentMenuList) // menuTree
          // let resData = await MenuNewMethods.getMenu1(currentMenuList)
          // console.log('防护',currentMenuList)

          if (test) {
            return resolve(routers)
          }
          return resolve(currentMenuList)
        }
      })
    })
    function initRouterOther (currentMenuList, allMenuList) {
      return new Promise(async (resolve) => {
        let otherRouter = config.routerList
        // console.log('otherRouter', otherRouter,allMenuList)
        await cctt(allMenuList)
        function cctt (list) {
          for (let routerName of otherRouter) {
            let otherRouterData = list.filter(router => {
              return router.name == routerName
            })

            let currentMenuRouter = currentMenuList.filter(router => {
              return router.name == routerName
            })
            if ((otherRouterData && otherRouterData.length > 0) && !(currentMenuRouter && currentMenuRouter.length > 0)) {
              if (otherRouterData && otherRouterData.length) {
                otherRouterData.forEach(router => {
                  router['type'] = 'other'
                })
                currentMenuList = currentMenuList.concat(otherRouterData)
              }
            }
          }
        }
        allMenuList.map((item, index) => {
          if (item.children && item.children.length > 0) {
            cctt(item.children)
          }
        })

        return resolve(currentMenuList)
      })
    }

    function initAllMenu (menu, userMenuList, menuAllList) {
      let tmpUserMenu = userMenuList[menu.meta.code]
      if (tmpUserMenu) {
        menuAllList.push(tmpUserMenu)
        if (menu.children && menu.children.length > 0) {
          menu.children.forEach(menuc => {
            initAllMenu(menuc, userMenuList, menuAllList)
          })
        }
      }
    }

    function initAllCodeGroupsMenu (code, userMenuList, menuAllList) {
      let tmpUserMenu = userMenuList[code]
      if (tmpUserMenu) {
        menuAllList.push(tmpUserMenu)
      }
    }

    function initMenuTree (menu, allMenuList) {
      let result = {}
      let tmpUserMenu = {}
      if (menu.customFlag) {
        tmpUserMenu = menu
      } else {
        tmpUserMenu = allMenuList.filter(mn => mn.code === menu.code)
      }

      if (tmpUserMenu && tmpUserMenu.length > 0) {
        Object.assign(result, tmpUserMenu[0])
        if (menu.children && menu.children.length > 0) {
          let children = []
          menu.children.forEach(menuc => {
            let menuC = initMenuTree(menuc, allMenuList)
            if (menuC) {
              children.push(menuC)
            }
          })
          result.children = children
          result.realChildren = children
        }
        return result
      } else if (menu.customFlag) {
        Object.assign(result, tmpUserMenu)
        return result
      }
    }

    function sortMenu (menuList) {
      menuList.sort((a, b) => {
        return a.sort - b.sort
      })
      menuList.forEach(menu => {
        if (menu.children && menu.children.length > 0) {
          sortMenu(menu.children)
        }
      })
    }
  }

  checkCodeShow = (code) => {
    if (test) {
      return true
    }

    if (!code) {
      return false
    }

    let userMenuList = JSON.parse(sessionStorage.getItem('menuList'))
    console.log(userMenuList,'lllllllllllll')

    if (!userMenuList) {
      return true
    }
    // console.log(userMenuList[code])
    if (userMenuList[code]) {
      return true
    } else {
      return false
    }
  }
}

export default new MenuMethods()
